import React, { useState, useCallback, useEffect } from "react";
import { Button, Checkbox, Icon, Modal, Spin } from "antd";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import moment from "moment";
// const { Option } = Select;
import { EXPENSE_STATUS_ID_TO_LABEL, EXPENSE_STATUS_ID, roles } from "./../../../configs/constants";
import {
  getExpenseReportsList,
  fetchExpenseReportsWeekly,
  fetchExpenseReportsUserWeekly,
  fetchUsersSectors
} from "./../actions/expenseReports";
import { ExpenseReportsProvider } from "./ExpenseReportsContext";
import ExpenseReportsFilters from "./ExpenseReportsFilters";
import PreviousBtn from "./../../../components/previousBtn/PreviousBtn";
import ExpenseReportsWeekly from "./expenseReportsWeekly/ExpenseReportsWeekly";
import ExpenseReportsList from "./expenseReportsList/ExpenseReportsList";
import WeeklyDetails from "./expenseReportsWeekly/weeklyDetails/WeeklyDetails";
import { startOfWeek } from "./ExpenseReports.utils";
import ModalComponent from "../../../components/modalComponent/ModalComponent";
import ExpenseForm from "../components/Expense.form";
import { getUsersWithoutExpensesApi } from "../api/api";
import FileSaver from "file-saver";

const UsersWithoutExpensesButton = ({ token, rangeDate }) => {
  let startDate = moment()
    .add(-2, "week")
    .startOf("week");
  let endDate = moment().endOf("day");
  if (Array.isArray(rangeDate) && rangeDate.length == 2) {
    startDate = rangeDate[0];
    endDate = rangeDate[1];
  }
  return (
    <Button
      type="primary"
      onClick={async () => {
        try {
          const data = await getUsersWithoutExpensesApi(token, {
            startDate,
            endDate
          });
          FileSaver.saveAs(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            `utilisateurs sans note de frais du ${moment(startDate).format("DD-MM-YYYY")} au ${moment(endDate).format(
              "DD-MM-YYYY"
            )}.xlsx`
          );
        } catch (e) {
          console.log(e);
        }
      }}
    >
      <Icon type="download" />{" "}
      {`Liste des salariés sans note de frais ${
        Array.isArray(rangeDate) && rangeDate.length === 2
          ? `du ${moment(startDate).format("DD-MM-YYYY")} au ${moment(endDate).format("DD-MM-YYYY")}`
          : "sur les deux dernières semaines"
      }`}
    </Button>
  );
};
const Help = () => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <React.Fragment>
      <Button type="primary" onClick={() => setIsVisible(true)}>
        Information
      </Button>
      <Modal
        title="Note de frais"
        visible={isVisible}
        onOk={() => setIsVisible(false)}
        onCancel={() => setIsVisible(false)}
      >
        <p style={{ marginBottom: 16 }}> Ecran avec la liste des notes de frais</p>

        <p style={{ marginTop: 4 }}>Actions possibles : </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          Manager : Voir les pièces jointes d'une NDF, les informations de la NDF ou modifier une NDF
        </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          Manager : L'acceptation d'une NDF se fait depuis la vue détail hébdomadaire (et non depuis l'écran liste)
        </p>

        <p style={{ marginTop: 16 }}>
          Remarque : la vue détail hébdomadaire d'un collaborateur est accessible en cliquant sur l'icone "calendrier"
          de la colonne "Semaine"
        </p>
      </Modal>
    </React.Fragment>
  );
};
const ExpenseReports = ({
  expenseReportsListData,
  usersSectors,
  fetchUsersSectors,
  userId,
  userRoleId,
  userInfos,
  expenseReportsList,
  expenseReportsWeeklyList,
  expenseReportsUserWeekly,
  fetchExpenseReportsUserWeekly,
  fetchExpenseReportsWeekly,
  fetchExpenseReportsList,
  token,
  userClientsIds,
  expenseReportsWeeklyData,
  userEmail,
  isLoading
}) => {
  const defaultStatusId =
    userRoleId === roles.MANAGER
      ? EXPENSE_STATUS_ID.PENDING
      : userRoleId === roles.TERRAIN
      ? undefined
      : EXPENSE_STATUS_ID.PREVALIDATED;
  const defaultLabel = EXPENSE_STATUS_ID_TO_LABEL[defaultStatusId];
  const [weekDate, setWeekDate] = useState(startOfWeek(moment()));
  const [rangeDate, setRangeDate] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePage, setCurrentSizePage] = useState(20);
  const [hideNotInWorkforce, setHideNotInWorkforce] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(defaultLabel);
  const [isWeeklyViewActive, setIsWeeklyViewActive] = useState(false);
  const [isDetailsViewActive, setIsDetailsViewActive] = useState(false);
  const [isFormExpenseVisible, setIsFormExpenseVisible] = useState(false);
  const [indexWeeklyCardOpen, setIndexWeeklyCardOpen] = useState(-1);
  const isPreviousBtnDisplayed = () => isDetailsViewActive;

  const getMatchParams = (view = "list") => {
    const match = {};

    if (selectedUserEmail) {
      if (view === "list") match["user_email"] = selectedUserEmail;
      else match["email"] = selectedUserEmail;
    }
    if (selectedClient) match["clients.label"] = selectedClient;
    if (selectedType && view === "list") match["type.def"] = selectedType;
    if (selectedStatus && view === "list") {
      const selectedStatusId = Object.keys(EXPENSE_STATUS_ID_TO_LABEL).find(
        key => EXPENSE_STATUS_ID_TO_LABEL[key] === selectedStatus
      );

      match["status.id"] = Number(selectedStatusId);
    }
    return match;
  };

  const requestFetchExpenseReportList = useCallback(
    (
      params = {
        page: 1,
        hideNotInWorkforce,
        match: {
          "status.id": defaultStatusId
        }
      }
    ) => {
      fetchExpenseReportsList({ ...params, pageSize: currentSizePage, sort: { date: -1 } });
    },
    [fetchExpenseReportsList, currentSizePage, hideNotInWorkforce]
  );

  useEffect(() => {
    requestFetchExpenseReportList({
      page: 1,
      hideNotInWorkforce,
      match: { ...getMatchParams(), ...getRangeRequestParams(rangeDate).match }
    });
  }, [selectedUserEmail, selectedStatus, selectedClient, selectedType, currentSizePage, hideNotInWorkforce]);

  const handleOnClickDetailsView = (params = {}) => {
    if (!isEmpty(params)) fetchExpenseReportsUserWeekly(params);
    if (params.match) setSelectedUserEmail(params.match.email);
    setIsDetailsViewActive(true);
  };

  const resetFilters = () => {
    setWeekDate(startOfWeek(moment()));
    setRangeDate();
    // setSelectedUserEmail(null);
    // setSelectedStatus(null);
    setSelectedRequest(null);
  };

  useEffect(() => {
    if (selectedUserEmail && isDetailsViewActive) {
      fetchExpenseReportsUserWeekly({
        start_date: moment(weekDate).format("YYYY-MM-DD"),
        match: {
          email: selectedUserEmail
        }
      });
    }
  }, [selectedUserEmail]);

  const requestFetchExpenseReportWeekly = useCallback(
    (params, weekDateSelected) => {
      params.start_date = weekDateSelected
        ? moment(weekDateSelected).format("YYYY-MM-DD")
        : moment(weekDate).format("YYYY-MM-DD");
      if (!params.match && selectedUserEmail) {
        params.match = {
          email: selectedUserEmail
        };
      }
      fetchExpenseReportsWeekly({
        ...params,
        pageSize: 10, //too slow if 20
        sort: { email: 1 }
      });
    },
    [fetchExpenseReportsWeekly]
  );

  const changeToListView = () => {
    requestFetchExpenseReportList();
    resetFilters();
    setIsWeeklyViewActive(false);
  };

  const changeToWeeklyView = () => {
    const params = { page: 1, pageSize: currentSizePage };

    requestFetchExpenseReportWeekly({ ...params, match: { ...getMatchParams("week") } });
    resetFilters();
    setIsWeeklyViewActive(true);
  };

  const onChangeView = () => {
    if (isWeeklyViewActive) changeToListView();
    else changeToWeeklyView();
  };

  useEffect(() => {
    requestFetchExpenseReportList();
  }, []);

  const getRangeRequestParams = rangeDates => {
    if (!rangeDates || !Array.isArray(rangeDates) || rangeDates.length !== 2) {
      return {
        page: 1,
        match: {}
      };
    }
    const startDate = rangeDates[0];
    const endDate = rangeDates[1];

    return {
      page: 1,
      match: {
        date: {
          $gte: { $date: moment(startDate).startOf("day") },
          $lte: { $date: moment(endDate).endOf("day") }
        }
      }
    };
  };

  const onChangeRangeDate = newRangeDate => {
    let filters = {};

    if (!isEmpty(newRangeDate)) {
      filters = getRangeRequestParams(newRangeDate);
    }

    setIndexWeeklyCardOpen(-1);
    requestFetchExpenseReportList({
      match: { ...filters.match, ...getMatchParams() },
      page: 1
    });
  };

  const onChangeWeekDate = newDate => {
    setWeekDate(newDate ? startOfWeek(newDate) : moment());
    const paramsToSend = {
      start_date: newDate ? moment(newDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      pageSize: 10
    };

    setIndexWeeklyCardOpen(-1);
    if (isDetailsViewActive) {
      fetchExpenseReportsUserWeekly({
        ...paramsToSend,
        match: {
          email: selectedUserEmail
        }
      });
    } else {
      if (selectedUserEmail)
        paramsToSend.match = {
          email: selectedUserEmail
        };
      fetchExpenseReportsWeekly({
        page: 1,
        ...paramsToSend
      });
    }
  };

  const handleOnClickPreviousBtn = () => {
    resetFilters();
    setIsDetailsViewActive(false);
  };

  const onChangeWeeklyPage = value => {
    requestFetchExpenseReportWeekly({
      page: value
    });
  };

  const onChangeListPage = value => {
    requestFetchExpenseReportList({
      page: value,
      match: { ...getMatchParams(), ...getRangeRequestParams(rangeDate).match }
    });
  };

  return (
    <div className="w-full">
      <div className="flex justify-between mb-5">
        <div className="flex items-center">
          {isPreviousBtnDisplayed() && <PreviousBtn onClick={() => handleOnClickPreviousBtn()} />}
          <div className="text-3xl font-bold text-gray-900">
            Note de frais {isDetailsViewActive && ": vue détail hebdomadaire"}
          </div>
        </div>
        <Help />
        {userRoleId <= roles.DIRECTOR && <UsersWithoutExpensesButton token={token} rangeDate={rangeDate} />}
        <div className="mt-12 mr-20">
          <div
            className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-gray-800 text-white"
            // onClick={() => setIsFormExpenseVisible(true)}
          >
            L'ajout de note de frais se fait désormais sur Lucca Clemmy
          </div>
        </div>
      </div>
      <ModalComponent
        title={`Ajout d'une note de frais`}
        width={700}
        showModal={isFormExpenseVisible}
        closeModal={() => setIsFormExpenseVisible(false)}
      >
        <ExpenseForm
          userInfos={userInfos}
          usersSectors={usersSectors}
          userClientsIds={userClientsIds}
          userRoleId={userRoleId}
          fetchUsersSectors={fetchUsersSectors}
          closeModal={() => setIsFormExpenseVisible(false)}
          token={token}
          requestFetch={isWeeklyViewActive ? requestFetchExpenseReportWeekly : requestFetchExpenseReportList}
        />
      </ModalComponent>
      <ExpenseReportsProvider
        value={{
          setSelectedType,
          selectedType,
          onChangeListPage,
          expenseReportsListData,
          requestFetchExpenseReportWeekly,
          userEmail,
          userId,
          token,
          userRoleId,
          handleOnClickDetailsView,
          onChangeView,
          onChangeWeekDate,
          weekDate,
          setWeekDate,
          onChangeRangeDate,
          expenseReportsUserWeekly,
          requestFetchExpenseReportList,
          expenseReportsWeeklyList,
          expenseReportsList,
          selectedRequest,
          setSelectedRequest,
          isWeeklyViewActive,
          setIsWeeklyViewActive,
          selectedStatus,
          setSelectedStatus,
          selectedUserEmail,
          setSelectedUserEmail,
          setRangeDate,
          rangeDate,
          isDetailsViewActive,
          setIsDetailsViewActive,
          fetchUsersSectors,
          onChangeWeeklyPage,
          currentPage,
          expenseReportsWeeklyData,
          selectedClient,
          setSelectedClient,
          hideNotInWorkforce
        }}
      >
        <ExpenseReportsFilters />

        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", paddingTop: 50 }}>
            <Spin />
          </div>
        )}
        {!isLoading && (
          <React.Fragment>
            {isDetailsViewActive && <WeeklyDetails expenseReportsUserWeekly={expenseReportsUserWeekly} />}
            {!isDetailsViewActive && isWeeklyViewActive && (
              <ExpenseReportsWeekly
                indexWeeklyCardOpen={indexWeeklyCardOpen}
                setIndexWeeklyCardOpen={setIndexWeeklyCardOpen}
              />
            )}
            {!isDetailsViewActive && !isWeeklyViewActive && (
              <React.Fragment>
                <div>
                  <Checkbox
                    checked={currentSizePage === 20}
                    onChange={() => setCurrentSizePage(v => (v === 20 ? 10 : 20))}
                  >
                    Afficher 20 éléments par page
                  </Checkbox>
                  <Checkbox checked={hideNotInWorkforce} onChange={() => setHideNotInWorkforce(v => !v)}>
                    Masquer les ndf hors effectif
                  </Checkbox>
                </div>
                <ExpenseReportsList
                  getRangeRequestParams={getRangeRequestParams}
                  getMatchParams={getMatchParams}
                  currentPage={expenseReportsListData ? expenseReportsListData.page : 1}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </ExpenseReportsProvider>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    expenseReportsList: (state.expenseReports.list && state.expenseReports.list.docs) || [],
    expenseReportsListData: state.expenseReports.list || [],
    expenseReportsWeeklyList: (state.expenseReports.weeklyList && state.expenseReports.weeklyList.docs) || [],
    expenseReportsWeeklyData: (state.expenseReports.weeklyList && state.expenseReports.weeklyList) || null,
    expenseReportsUserWeekly: state.expenseReports.userWeekly,
    token: state.auth.token,
    userRoleId: state.userInfos.role_id,
    userId: state.userInfos._id,
    userEmail: state.userInfos.email,
    userInfos: state.userInfos,
    userClientsIds: !isEmpty(state.userInfos.clients) ? state.userInfos.clients.map(item => item.id) : null,
    usersSectors: state.usersSectors && state.usersSectors.usersSectorsList,
    isLoading: state.expenseReports.isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchExpenseReportsList: params => {
      dispatch(getExpenseReportsList(params));
    },
    fetchExpenseReportsWeekly: params => {
      dispatch(fetchExpenseReportsWeekly(params));
    },
    fetchExpenseReportsUserWeekly: params => {
      dispatch(fetchExpenseReportsUserWeekly(params));
    },
    fetchUsersSectors: params => {
      dispatch(fetchUsersSectors(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseReports);



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReports.js